
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Rubrique from '@/extend/classes/Rubrique';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeRubrique' })

export default class storeRubrique extends VuexModule {
  // States
  private reccords: Rubrique[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get rubriqueLoading (): boolean {
    return this.dataLoading;
  }
  private get rubriqueRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get rubriqueLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewRubrique() {
    return (): Rubrique => { 
      return this.getRubrique(0, true);
    }
  }

  
  public get getRubrique () {
    return (id: number, canCreate = false): Rubrique => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Rubrique can't be 0")
        return new Rubrique();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Rubrique();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Rubrique.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromRubrique(data.reccords[0] as Rubrique);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listRubrique (): Rubrique[] {
    return this.reccords;
  }

  public get listConfigRubrique (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mRubriqueRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mRubriqueClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mRubriqueLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mRubriqueLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Rubrique.fromJson(reccord as Rubrique));
    })
    Rubrique.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mRubriqueConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mRubriqueCreated (obj: Rubrique): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareRubrique(obj)) {
          api.fromRubrique(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareRubrique(obj)) {
            api.fromRubrique(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mRubriqueUpdated (obj: Rubrique): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareRubrique(obj)) {
          api.fromRubrique(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mRubriqueDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerRubrique (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.rubriqueRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerRubrique(this.rubriqueCreated, this.rubriqueUpdated, this.rubriqueDeleted);
          this.mRubriqueRegistered();
        } else {
          setTimeout(() => resolve(this.registerRubrique(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.rubriqueLoading && !this.rubriqueLoaded) {
          this.mRubriqueLoading(true);
          return Rubrique.list(filter)
            .then((data: ListData) => {
              this.mRubriqueLoaded(data);
              this.mRubriqueLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredRubrique (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.rubriqueLoading) {
        this.mRubriqueLoading(true);
        return Rubrique.list(filter)
          .then((data: ListData) => {
            this.mRubriqueLoaded(data);
            this.mRubriqueLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createRubrique (obj: Rubrique): Promise<Rubrique> {
    return new Promise((resolve, reject) => {
      return Rubrique.fromJson(obj).createForStoreRubrique()
        .then((reccords) => {
          this.mRubriqueCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateRubrique (obj: Rubrique): Promise<Rubrique> {
    return new Promise((resolve, reject) => {
      return Rubrique.fromJson(obj).updateForStoreRubrique()
        .then((reccords) => {
          this.mRubriqueUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteRubrique (obj: Rubrique): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Rubrique.fromJson(obj).deleteForStoreRubrique()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mRubriqueDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private rubriqueCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mRubriqueConfigUpdated(config)
    const obj = objConfig.obj as Rubrique;
    this.mRubriqueCreated(Rubrique.fromJson(obj));
  }

  @Action
  private rubriqueUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mRubriqueConfigUpdated(config)
    const obj = objConfig.obj as Rubrique;
    this.mRubriqueUpdated(Rubrique.fromJson(obj));
  }

  @Action
  private rubriqueDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Rubrique;
    this.mRubriqueDeleted(obj.id);
  }
}
